import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";

import { editUser as editUserAPI } from "api/users";
import { usersKeys } from "api/users/queries";
import { EditUserType, UsersType } from "api/users/types";
import AppDialog from "components/AppDialog";
import ModalHeader from "components/AppDialog/ModalHeader";

import UserForm, { UserFormValues } from "./UserForm";

// LOGIC:

// TYPES:

interface NewUserModalProps {
  isOpen: boolean;
  handleClose: () => void;
  user: UsersType | undefined;
}

const EditUserModal = ({ isOpen, handleClose, user }: NewUserModalProps) => {
  const queryClient = useQueryClient();

  const initialValues: UserFormValues = {
    organisation: user?.organisation || "",
    email: user?.email || "",
    role: user?.role || null,
  };

  const { mutateAsync: editUser, status } = useMutation(
    async (data: EditUserType) => {
      const res = await editUserAPI(data);
      await queryClient.invalidateQueries(usersKeys.list());
      return res.data;
    },
  );

  const handleSubmit = async (values: UserFormValues) => {
    const mappedValues: EditUserType = {
      _id: user!._id,
      ...values,
    };
    await editUser(mappedValues, {
      onSuccess: () => handleClose(),
    });
  };

  return (
    <AppDialog open={isOpen} onClose={handleClose} maxWidth="md">
      <ModalHeader title="Edit User" subtitle="Update user email and role." />
      <UserForm
        submitStatus={status}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        initialValues={initialValues}
      />
    </AppDialog>
  );
};

export default EditUserModal;
